module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzNCAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2Ljc3NyAwSDMxLjk5MDVMMjAuNjAwNSAxMy41NTQ5TDM0IDMySDIzLjUwODNMMTUuMjkwOCAyMC44MTMxTDUuODg4MDggMzJIMC42NzEzOTVMMTIuODU0MiAxNy41MDE1TDAgMEgxMC43NTgxTDE4LjE4NiAxMC4yMjUyTDI2Ljc3NyAwWk0yNC45NDcyIDI4Ljc1MDhIMjcuODM2MUw5LjE4ODMxIDMuMDc4NThINi4wODgyMUwyNC45NDcyIDI4Ljc1MDhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/icon/svg/x.svg
// module id = f+kQ
// module chunks = 8